module.exports = __webpack_public_path__ + "16e6b13f2edea60a16b5db6443a92a7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/detsky-tabor-1-3.jpg
// module id = 1213
// module chunks = 0